import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import classnames from 'classnames';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import styles from './AutoDirector.module.css';
import { getDirectors } from './AutoDirectors.actions';
import DirectorName from './DirectorName';
import messages from './LimitedCompany.messages';
import DropDown from '../../DropDown/';
import Option from '../../DropDown/Option';

const mapStateToProps = ({ fetched }) => ({
    directors: fetched.directors
});

const mapDispatchToProps = (dispatch) => ({
    getCompanyDirectors: () => dispatch(getDirectors())
});

class AutoDirector extends React.Component {
    renderContinueWithCurrentNameOption = ({ searchTerm, closeSearchMenu }) => {
        const { firstNameField, lastNameField } = this.props;
        const firstName = searchTerm[firstNameField.name] || '';
        const lastName = searchTerm[lastNameField.name] || '';
        const hasSpace = firstName && lastName ? ' ' : '';
        const fullName = `${firstName}${hasSpace}${lastName}`;
        return (
            <Option
                onClick={() => closeSearchMenu()}
                optionRenderer={() => (
                    <FormattedMessage
                        {...messages.continueWithName}
                        values={{ fullName }}
                    />
                )}
                item={null}
            />
        );
    };

    renderNoResults = (searchTerm, { closeSearchMenu }) => {
        return this.renderContinueWithCurrentNameOption({
            searchTerm,
            closeSearchMenu
        });
    };

    renderNoSearchTerm = ({ searchTerm, closeSearchMenu }) => {
        const { firstNameField, lastNameField } = this.props;
        if (searchTerm[firstNameField.name] || searchTerm[lastNameField.name]) {
            return this.renderContinueWithCurrentNameOption({
                searchTerm,
                closeSearchMenu
            });
        }

        return (
            <div className="no-results-custom">
                <span
                    className={classnames(styles.noSearchTermMessage, 'body')}>
                    <FormattedMessage {...messages.searchForDirector} />
                </span>
            </div>
        );
    };

    render() {
        const {
            firstNameField,
            lastNameField,
            directors,
            getCompanyDirectors
        } = this.props;

        const fullName = `${firstNameField.value}${lastNameField.value}`;
        const directorNames = directors.list;
        const relevantDirectorNames = directorNames.filter(
            (d) =>
                (firstNameField.value &&
                    _.includes(
                        _.lowerCase(d.first_name),
                        firstNameField.value.toLowerCase()
                    )) ||
                (lastNameField.value &&
                    _.includes(
                        _.lowerCase(d.last_name),
                        lastNameField.value.toLowerCase()
                    ))
        );
        return (
            <DropDown.AsyncLive
                getOptions={() => {
                    if (!directorNames.length) {
                        getCompanyDirectors();
                    }
                }}
                items={relevantDirectorNames}
                isSuccess={directors.success}
                isLoading={directors.fetching}
                optionRenderer={(director) => (
                    <span>
                        {director.first_name} {director.last_name}
                    </span>
                )}
                value={fullName}
                onSelect={(director) => {
                    firstNameField.onChange(director.first_name);
                    lastNameField.onChange(director.last_name);
                    tracking.ampli.formFieldCompleted({
                        form_field: 'first_name'
                    });
                    tracking.ampli.formFieldCompleted({
                        form_field: 'last_name'
                    });
                }}
                noResultsRenderer={this.renderNoResults}
                noSearchTermRenderer={this.renderNoSearchTerm}
                initialSearchTerm={{
                    [firstNameField.name]: firstNameField.initialValue,
                    [lastNameField.name]: lastNameField.initialValue
                }}
                renderSearch={DirectorName({
                    firstNameField,
                    lastNameField
                })}
                renderTopElement={({ searchTerm, closeSearchMenu }) => (
                    <div className="iwoca-select-container">
                        {this.renderContinueWithCurrentNameOption({
                            searchTerm,
                            closeSearchMenu
                        })}
                    </div>
                )}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoDirector);
